import DownloadSprievodnyDokumentListButton from './DownloadSprievodnyDokumentListButton';

export default DownloadSprievodnyDokumentListButton;
